import { cn, useMedias } from '@divlab/divanui';
import { IconChevronRight } from '@divlab/divanui/icons';

import useTranslation from '@Queries/useTranslation';
import styles from './HideMapButton.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface HideMapButtonProps extends HTMLAttributes<HTMLButtonElement> {
  open: boolean;
}

const HideMapButton: FC<HideMapButtonProps> = (props) => {
  const { open, className, ...restProps } = props;
  const { t } = useTranslation();
  const { isMobile } = useMedias();

  return (
    <button
      {...restProps}
      type='button'
      className={cn(styles.buttonContainer, className, {
        [styles.closedButton]: open && !isMobile,
      })}
    >
      {isMobile && <span>{t(open ? 'ui.map.hide-list' : 'ui.map.show-list')}</span>}
      <IconChevronRight
        className={cn({
          [styles.icon]: isMobile,
          [styles.iconHide]: open,
          [styles.desktopIcon]: !open && !isMobile,
        })}
      />
      {!open && !isMobile && <span>{t('ui.map.show-list')}</span>}
    </button>
  );
};

export default HideMapButton;
